var $ = require('jquery');
require('bootstrap');
require('jquery-countto');
require('slick-carousel');
require('./utilities/class_enlarge.js');
require('./utilities/class_count.js');
require('./utilities/pdw_burger_menu.js');
require('./utilities/pdw_mobile_menu.js');
require('./utilities/pdw_modal_search.js');
var Luminous = require('luminous-lightbox').Luminous;
var LuminousGallery = require('luminous-lightbox').LuminousGallery;

$(function() {
    //Carousel init
    $('.pdw-carousel,.pdw-slick')
        .slick()
        .delay(2000)
        .slick('setPosition');
    //Lightbox init
    new LuminousGallery(document.querySelectorAll(".luminous-lightbox"));
    //Page animation
    $('[href^="http"]').click(function (e){
        if($(this).attr('target')!='_blank'){
            $('body').addClass('leaving');
            window.location.href = $(this).attr('href');
        }
    });
});
